<div
  pplDropZone
  (pplDropZoneOver)="setDragOver($event)"
  (pplDropZoneDrop)="onDrop($event)"
  class="image-container"
  [class.round]="forceRound"
  [style.width]="imageWidth"
  [style.height]="imageHeight"
  [style.background-color]="backgroundColor">
  @if (dragOver) {
    <div class="overlay">
      <ppl-icon
        svgIcon="color-upload"
        width="20px"
        height="20px"></ppl-icon>
      <div class="overlay-text">
        {{ dropMessage }}
      </div>
    </div>
  }
  @if (picture) {
    <img
      class="image"
      [class.contain]="containPicture"
      [src]="picture" />
  }
  @if (!picture) {
    <ppl-icon
      class="image"
      [svgIcon]="iconName"
      width="48px"
      height="48px"></ppl-icon>
  }
</div>

@if (isEditable) {
  @if (optionsCount === 1 && options.includes('browse')) {
    <label
      (click)="fileSelector.click()"
      pplButton
      pplButton1
      class="edit"
      #editBtn>
      <ppl-icon
        width="18px"
        height="14px"
        svgIcon="icon-photo"
        [hoverEnabled]="true"
        [actionElement]="editBtn.elementRef.nativeElement">
      </ppl-icon>
    </label>
  } @else {
    <button
      type="button"
      [pplPopover]="buttonPopoverOptions"
      pplPopoverAlignStart
      pplButton
      pplButton1
      class="edit"
      #editBtn2>
      <ppl-icon
        width="18px"
        height="14px"
        svgIcon="icon-photo"
        [states]="[
          {
            name: 'hover',
            active: editBtn2.elementRef.nativeElement.classList.contains('popover-active'),
          },
        ]"
        [hoverEnabled]="true"
        [actionElement]="editBtn2.elementRef.nativeElement">
      </ppl-icon>
    </button>
    <ng-template #buttonPopoverOptions>
      <ppl-popover-dropdown>
        <ppl-menu>
          @if (options.includes('browse')) {
            <ppl-menu-item
              pplPopoverClose
              (click)="fileSelector.click()"
              >{{ browse }}</ppl-menu-item
            >
          }
          @if (options.includes('insertFromUrl')) {
            <ppl-menu-item
              pplPopoverClose
              (click)="onInsertFromURL()"
              >{{ insertFromUrl }}</ppl-menu-item
            >
          }
          @if (options.includes('remove')) {
            <ppl-menu-item
              pplPopoverClose
              (click)="onImageRemove()"
              >{{ remove }}</ppl-menu-item
            >
          }
        </ppl-menu>
      </ppl-popover-dropdown>
    </ng-template>
  }
  <input
    #fileSelector
    type="file"
    style="display: none"
    accept="image/jpg,image/jpeg,image/png"
    (change)="onSelectFile($event)"
    (cancel)="$event.stopPropagation()" />
}
